/* RunAudit.js */

"use strict";
// const _ = require("lodash");

class RunAudit {
    constructor(model) {
        this._model = model;
        this._modalUserFeedback = this._model._modalUserFeedback;
        this._parentModel = this._model._parentModel;
        this._logger = this._model._logger;
    }

    _shutdown() {
        this._model = undefined;
        this._modalUserFeedback = undefined;
        this._parentModel = undefined;
        this._logger = undefined;
        return Promise.resolve();
    }

    _getWorkInput(pristineProperties) {
        const title = `Audit Run - ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`;
        return {
            auditTitle: title,
            captureNewSnapShots: false,
            snapshotName: undefined,
            policyId: pristineProperties.auditPolicy.id,
        };
    }

    _progressCallBack({workId, successCount, failureCount, targetCount}) {
        if (workId) {
            this._parentModel._workId = workId;
        }
        let msg = `Succeeded ${successCount}, failed ${failureCount} of ${targetCount} devices`;
        this._modalUserFeedback.showLoadingProgress(msg);
    }

    _abortAuditWork() {
        this._model._gameEditor._ConfigAuditPolicyEntity.cancelWork(
            this._model._value.tenantId,
            this._parentModel._workId
        );
        const title = "Audit Aborted";
        const msg = "Audit aborted by user";
        return this._modalUserFeedback.displayNotification(msg, {title});
    }

    _rerunAudit() {
        let aborted = false;
        this._model._value
            .loadRelatedWork({targets: true, workTarget: true})
            .then((workEntity) => {
                const tenantId = this._model._value.tenantId;
                const workInput = this._getWorkInput(this._model._value.pristineProperties);
                const workTarget = workEntity.workTarget;
                const progressCb = this._progressCallBack.bind(this);

                return Promise.resolve({tenantId, workInput, workTarget, progressCb});
            })
            .then(({tenantId, workInput, workTarget, progressCb}) => {
                this._modalUserFeedback.displayLoading({
                    message: "Auditing your devices...",
                    showHideButton: true,
                    showAbortButton: true,
                    onAbort: () => {
                        aborted = true;
                        this._abortAuditWork();
                    },
                });

                return this._model._gameEditor._ConfigAuditPolicyEntity.runAuditWork(
                    tenantId,
                    workTarget,
                    workInput,
                    {launchAndForget: false},
                    progressCb
                );
            })
            .then((result) => {
                if (aborted) {
                    return;
                }
                if (result.errorMsg) {
                    let err = new Error(result.errorMsg);
                    err.errorCode = "ConfigAuditError";
                    err.errorMsg = result.errorMsg;
                    throw err;
                }
                if (!this._modalUserFeedback.isStillOpen) {
                    return;
                }
                let userNotificationMessage = "";
                if (!result.summary) {
                    userNotificationMessage = `Total number of devices: ${
                        result._trimmed.targetResults || 0
                    }`;
                } else {
                    const {
                        deviceCount,
                        deviceSuccessCount,
                        deviceErrorCount,
                        devicesInViolationCount,
                        violationCount,
                        devicesSkippedCount,
                    } = result.summary;
                    userNotificationMessage = [
                        `Total devices: ${deviceCount || 0}`,
                        `Audited devices: ${deviceSuccessCount || 0}`,
                        `Skipped Devices:${devicesSkippedCount}` || 0,
                        `Device errors: ${deviceErrorCount || 0}`,
                        "",
                        `Devices in violation: ${devicesInViolationCount || 0}`,
                        `Total violations: ${violationCount || 0}`,
                    ].join("\r\n");
                }
                return this._model._gameEditor._ConfigAuditPolicyEntity
                    .retrieve(result.tid, "ConfigAuditPolicy", this._model._value.auditPolicy.id)
                    .then((auditPolicy) => {
                        return auditPolicy.retrieveMostRecentExecution();
                    })
                    .then((executionEntity) => {
                        return this._modalUserFeedback
                            .displayConfirmation(userNotificationMessage, {
                                title: "Audit Completed",
                                confirmDetails: {
                                    text: "View Results",
                                    type: "additive",
                                },
                                rejectDetails: {
                                    text: "OK",
                                    type: "text",
                                },
                            })
                            .then(() => {
                                if (result.summary && result.summary.policyId) {
                                    this._model.emit(
                                        "SwitchView",
                                        "AUDIT_POLICY_EDITOR_VIEW_RESULTS",
                                        {
                                            isSubView: true,
                                            configExecutionEntity: executionEntity,
                                        }
                                    );
                                    return Promise.resolve();
                                } else {
                                    this._logger.warn(
                                        {error: {}},
                                        "Run Audit from Summary, _startConfigAuditWork() - No policyId received"
                                    );
                                    return Promise.reject();
                                }
                            });
                    });
            })
            .catch((err) => {
                if (aborted) {
                    return;
                }
                if (err && err.closed) {
                    this._modalUserFeedback.hideDisplayed();
                    return Promise.resolve();
                }
                if (err && !err.userRejected) {
                    if (this._logger) {
                        this._logger.warn(
                            {error: err},
                            "Run Audit from Summary, _startConfigAuditWork() - Error"
                        );
                    } else {
                        console.error(err);
                    }
                    return this._modalUserFeedback.displayError(err);
                }
            });
    }
}

module.exports = RunAudit;
